import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../../shared';
import { TranslateModule } from '@ngx-translate/core';
import { PremiumPage } from './premium';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    PremiumPage
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{ path: '', component: PremiumPage }]),
    TranslateModule.forChild(),
    SharedModule
  ],
  exports: [
    PremiumPage
  ]
})
export class PremiumPageModule {}
